/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const SupportDocument = gql`
    mutation Support($subject: String!, $message: String!, $file: String) {
  support(subject: $subject, message: $message, file: $file)
}
    `;
export type SupportMutationFn = Apollo.MutationFunction<SupportMutation, SupportMutationVariables>;

/**
 * __useSupportMutation__
 *
 * To run a mutation, you first call `useSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportMutation, { data, loading, error }] = useSupportMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      message: // value for 'message'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSupportMutation(baseOptions?: Apollo.MutationHookOptions<SupportMutation, SupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportMutation, SupportMutationVariables>(SupportDocument, options);
      }
export type SupportMutationHookResult = ReturnType<typeof useSupportMutation>;
export type SupportMutationResult = Apollo.MutationResult<SupportMutation>;
export type SupportMutationOptions = Apollo.BaseMutationOptions<SupportMutation, SupportMutationVariables>;
export type SupportMutationVariables = Types.Exact<{
  subject: Types.Scalars['String']['input'];
  message: Types.Scalars['String']['input'];
  file?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SupportMutation = { __typename?: 'Mutation', support: boolean };
